import React, { useState } from "react";
import Banners from "./Banners";
import BannerLocations from "./BannerLocations";

export default function Banner() {
  const [activeTab, setActiveTab] = useState("banners");

  const renderTabContent = () => {
    if (activeTab === "banners") {
      return <Banners />;
    } else {
      return <BannerLocations />;
    }
  };

  return (
    <>
      <div className="flex flex-col space-y-6">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl">Add Banners</h2>
        </div>
        <hr className="border-b border-gray-200" />

        <div className="flex ">
          <button
            className={`rounded-l-md py-2 px-12 ${
              activeTab === "banners"
                ? "bg-[#4E5662] text-white"
                : "border border-gray-500 bg-[#F8F8F8] text-[#6D7C94]"
            }`}
            onClick={() => setActiveTab("banners")}
          >
            Banners
          </button>
          <button
            className={`rounded-r-md py-2 px-12 ${
              activeTab === "locations"
                ? "bg-[#4E5662] text-white"
                : "border border-gray-500 bg-[#F8F8F8] text-[#6D7C94]"
            }`}
            onClick={() => setActiveTab("locations")}
          >
            Locations
          </button>
        </div>

        {renderTabContent()}
      </div>
    </>
  );
}
